export default __webpack_public_path__ + "static/media/iphone-home-6.5.195a675b.jpg";